import React from 'react';
import FooterPageLayout from '../../components/layouts/FooterPageLayout';

const Partnerships = () => {
  const partnershipTypes = [
    {
      title: "Event Organizer Partnership",
      description: "Get featured in our Browse Events section and reach thousands of potential vendors",
      benefits: [
        "Featured in our newsletter and social media",
        "We'll capture content at your event",
        "Featured listing in Browse Events",
        "Case study spotlight opportunity"
      ]
    },
    {
      title: "Vendor Partnership",
      description: "Showcase your exclusive deals and grow your brand on our marketplace",
      benefits: [
        "Featured in our newsletter and social media",
        "We'll capture content of your products",
        "Promote exclusive deals on marketplace",
        "Featured vendor case studies"
      ]
    },
    {
      title: "Strategic Alliance",
      description: "Partner with tourism boards, chambers of commerce, downtown development authorities, brands, venues, and community organizations",
      benefits: [
        "Custom integration opportunities",
        "Co-branded marketing campaigns",
        "Community event promotion",
        "Featured partnership spotlights"
      ]
    }
  ];

  return (
    <FooterPageLayout>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#B22A2B] mb-4">Partnerships</h1>
          <p className="text-xl text-[#4A5568] max-w-2xl mx-auto">
            Partner with Pebble to grow your business and reach new customers. We offer various partnership opportunities
            to help you succeed in the digital marketplace.
          </p>
        </div>

        <section className="mb-12 bg-white rounded-xl shadow-sm p-8 hover:shadow-md transition-shadow duration-300">
          <h2 className="text-2xl font-semibold text-[#B22A2B] mb-6">Partnership Benefits</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-[#F7FAFC] rounded-xl p-6">
              <h3 className="font-semibold text-[#B22A2B] mb-2">Featured Promotion</h3>
              <p className="text-[#4A5568]">Get featured in our newsletter, social media, and Browse Events section</p>
            </div>
            <div className="bg-[#F7FAFC] rounded-xl p-6">
              <h3 className="font-semibold text-[#B22A2B] mb-2">Content Creation</h3>
              <p className="text-[#4A5568]">We'll capture professional content at your event or of your products</p>
            </div>
            <div className="bg-[#F7FAFC] rounded-xl p-6">
              <h3 className="font-semibold text-[#B22A2B] mb-2">Case Studies</h3>
              <p className="text-[#4A5568]">Showcase your success story through featured case study opportunities</p>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <div className="space-y-6">
            {partnershipTypes.map((type, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#E2E8F0]">
                <h3 className="text-xl font-semibold text-[#B22A2B] mb-2">{type.title}</h3>
                <p className="text-[#4A5568] mb-4">{type.description}</p>
                <div className="grid md:grid-cols-2 gap-4">
                  {type.benefits.map((benefit, benefitIndex) => (
                    <div key={benefitIndex} className="flex items-start">
                      <svg className="w-5 h-5 text-[#B22A2B] mt-1 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-[#4A5568]">{benefit}</span>
                    </div>
                  ))}
                </div>
                <button className="mt-4 bg-[#B22A2B] text-white px-4 py-2 rounded-lg hover:bg-[#8a2122] transition-colors text-sm">
                  Contact Us
                </button>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-white rounded-xl shadow-sm p-8 hover:shadow-md transition-shadow duration-300">
          <h2 className="text-2xl font-semibold text-[#B22A2B] mb-4">Ready to Partner with Us?</h2>
          <p className="text-[#4A5568] mb-6">
            Take the first step towards growing your business with Pebble. Our partnership team is ready to help you succeed.
          </p>
          <button className="bg-[#B22A2B] text-white px-6 py-3 rounded-lg hover:bg-[#8a2122] transition-colors font-medium">
            Apply for Partnership
          </button>
        </section>
      </div>
    </FooterPageLayout>
  );
};

export default Partnerships; 